import { Flex } from "@aircall/tractor";

import { SectionDetails } from "../SectionDetails";
import { SectionTranscript } from "../SectionTranscript/SectionTranscript";

import { useCall } from "@/hooks/useCall/useCall";
import { useTrackAssetsPageOpen } from "@/hooks/useTrackAssetsPageOpen/useTrackAssetsPageOpen";

export function Body() {
  const { call } = useCall();

  useTrackAssetsPageOpen();

  if (!call) {
    return null;
  }

  return (
    <Flex overflow="auto" flexGrow={1} background="#F7F7F7">
      <SectionDetails />
      <SectionTranscript />
    </Flex>
  );
}
